export enum PaymentTypes {
    Cash = 0,
    Visa = 1,
}
